import React from 'react';
import { IUsePlaySoundProps, usePlaySound } from 'react-scale/corp/hooks/usePlaySound';

interface IWithPlaySoundProps extends IUsePlaySoundProps {
  children: React.ReactNode;
}

export function WithPlaySound(props: IWithPlaySoundProps) {
  const { playSound } = usePlaySound(props);

  return <div onClick={playSound}>{props.children}</div>;
}
